import { Checkbox, Label } from "@simplicity/ui";

import { type GroupDashboard } from "./types";

export function GroupDashboardsTable({
  groupId,
  dashboards,
  assignedDashboardIds,
  onToggle,
}: {
  groupId: string;
  dashboards: GroupDashboard[];
  assignedDashboardIds: string[];
  onToggle: (dashboardId: string) => void;
}) {
  return (
    <div>
      <h4 className="text-xs font-semibold text-muted-foreground mb-2">Dashboards</h4>
      {dashboards.length === 0 ? (
        <p className="text-xs text-muted-foreground">No dashboards available.</p>
      ) : (
        <table className="w-full text-xs">
          <thead>
            <tr className="text-left text-muted-foreground border-b border-border">
              <th className="pb-1 pr-2 w-8"></th>
              <th className="pb-1 pr-3 font-medium">Name</th>
              <th className="pb-1 pr-3 font-medium">Category</th>
              <th className="pb-1 font-medium">Year</th>
            </tr>
          </thead>
          <tbody>
            {dashboards.map((d) => (
              <tr key={d.id} className="border-b border-border last:border-0">
                <td className="py-1 pr-2">
                  <Checkbox
                    id={`dash-${groupId}-${d.id}`}
                    checked={assignedDashboardIds.includes(d.id)}
                    onCheckedChange={() => onToggle(d.id)}
                  />
                </td>
                <td className="py-1 pr-3">
                  <Label htmlFor={`dash-${groupId}-${d.id}`} className="cursor-pointer">
                    {d.title}
                  </Label>
                </td>
                <td className="py-1 pr-3 text-muted-foreground">{d.category || "—"}</td>
                <td className="py-1 text-muted-foreground">{d.school_year || "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
